import { List, Map, fromJS } from 'immutable';

export function request(state, { id, name }) {
    id = parseInt(id, 10);

    let transactions = state.get('transactions') || Map();
    let user = transactions.get(id) || Map();

    user = user.set(
        name,
        (user.get(name) || Map())
            .set('state', 'IN_PROGRESS')
            .set('errors', void 0)
    );

    return state.set(
        'transactions', transactions.set(id, user)
    );
}

export function error(state, { id, name, errors }) {
    id = parseInt(id, 10);

    let transactions = state.get('transactions') || Map();
    let user = transactions.get(id) || Map();

    user = user.set(
        name,
        (user.get(name) || Map())
            .set('list', List())
            .set('state', 'ERROR')
            .set('errors', fromJS(errors))
    );

    return state.set(
        'transactions', transactions.set(id, user)
    );
}

export function finish(state, { id, name, transactions }) {
    id = parseInt(id, 10);

    let transactionsEl = state.get('transactions') || Map();
    let user = transactionsEl.get(id) || Map();

    user = user.set(
        name,
        (user.get(name) || Map())
            .set('list', fromJS(transactions))
            .set('state', 'FINISHED')
            .set('errors', void 0)
    );

    return state.set(
        'transactions', transactionsEl.set(id, user)
    );
}

export function clear(state) {
    return state.set('transactions', Map());
}
